import { APIMethod, fetchData } from "@client";

export async function acceptLibraryElementQuery(elementId) {
  await fetchData(`/v1/library/accepted/${elementId}`, APIMethod.PATCH);
}
